import React from 'react';
import classnames from 'classnames';
import { useMiwiStore } from '../../../store';
import './OpenOverride.scss';

type OpenOverrideProps = {
    onMouseUp: () => void;
};

const OpenOverride = ({
    onMouseUp,
}: OpenOverrideProps) => {
    const {overrideMediaUrl,overrideDealerId, overrideDeviceId} = useMiwiStore();
    const classes = classnames('b-open-override ', {
        'override-with-no-control': overrideMediaUrl === '',
        'override-with-control': overrideMediaUrl !== ''
    });

    const iconClasses = classnames({
        'override-connected': overrideDeviceId,
        'override-online': overrideDealerId,
        'override-offline': !overrideDealerId
    });
    return (
        <div onMouseUp={() => onMouseUp()} className={classes}>
            <span className={iconClasses} data-testid="override-button" />
        </div>
    );
};

export default OpenOverride;
